module.exports = __webpack_public_path__ + "static/balalaika-bass_1600.582d48d5.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/photos/balalaika-bass_1600.jpg
// module id = 632
// module chunks = 0